module.exports = __webpack_public_path__ + "static/media/VestasSans-Heavy.2599e97a.eot";